import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { BANK_TRANSACTION_STATUS } from '../enums';

@Pipe({
  name: 'bankTransactionStatus'
})
export class BankTransactionStatusPipe extends EnumConverter implements PipeTransform {
  enumeration = BANK_TRANSACTION_STATUS;
}
